module.exports = __webpack_public_path__ + "img/zla.32b8f9a9.png";